// Create the main myMSALObj instance
// configuration parameters are located at authConfig.js

import { msalConfig, loginRequest, tokenRequest } from './authConfig.js';

const myMSALObj = new msal.PublicClientApplication(msalConfig);

let username = "";

// Maneja la promesa de redireccionamiento
myMSALObj.handleRedirectPromise()
    .then((response) =>{
        if(response !== null) {
            handleResponse(response);
        }else{
            selectAccount();
        }
    })
    .catch((error) => {
        console.error("Error en el manejo del redireccionamiento:", error);
    });

function selectAccount() {
    const currentAccounts = myMSALObj.getAllAccounts();
    
    if (currentAccounts.length === 0) {
        console.warn("No se encontraron cuentas.");
        return;
    } else if (currentAccounts.length > 1) {
        console.warn("Múltiples cuentas detectadas.");
    } else if (currentAccounts.length === 1) {
        username = currentAccounts[0].username;
    }
}
function handleResponse(response) {
    if (response !== null) {
        username = response.account.username;
        localStorage.setItem('userEmail', response.account.username);
        localStorage.setItem('nombreUsr', response.account.name);

        getTokenRedirect(tokenRequest)
            .then(resp => {
                localStorage.setItem('id_token', resp.accessToken);
                localStorage.setItem('authenticated', 'true');  // Marcamos como autenticado
                window.location.replace('cuadroMando');  // Una vez logeado y conseguido el token, cargamos la página de cuadroMando.
            })
            .catch(error => {
                console.error("Error al adquirir el token:", error);
            });
    } else {
        selectAccount();
    }
}

function signIn() {
//    localStorage.removeItem('authenticated');  // Limpiamos el estado de autenticación al iniciar sesión
    myMSALObj.loginRedirect(loginRequest);
}

function getTokenRedirect(request) {
    /**
     * See here for more info on account retrieval:
     * https://github.com/AzureAD/microsoft-authentication-library-for-js/blob/dev/lib/msal-common/docs/Accounts.md
     */
    request.account = myMSALObj.getAccountByUsername(username);
    return myMSALObj.acquireTokenSilent(request).catch((error) => {
        console.error(error);
        console.warn('silent token acquisition fails. acquiring token using popup');
        if (error instanceof msal.InteractionRequiredAuthError) {
            // fallback to interaction when silent call fails
            return myMSALObj.acquireTokenRedirect(request);
        } else {
            console.error(error);
        }
    });
}

function signOut() {

    /**
     * You can pass a custom request object below. This will override the initial configuration. For more information, visit:
     * https://github.com/AzureAD/microsoft-authentication-library-for-js/blob/dev/lib/msal-browser/docs/request-response-object.md#request
     */
    localStorage.removeItem('authenticated');  // Limpiamos el estado de autenticación al cerrar sesión

    const logoutRequest = {
        account: myMSALObj.getAccountByUsername(username),
        postLogoutRedirectUri: msalConfig.auth.redirectUri,
    };

    myMSALObj.logoutRedirect(logoutRequest);
}

function seeProfile() {
    getTokenRedirect(loginRequest)
        .then(response => {
            callMSGraph(graphConfig.graphMeEndpoint, response.accessToken, updateUI);
        }).catch(error => {
            console.error(error);
        });
}

function readMail() {
    getTokenRedirect(tokenRequest)
        .then(response => {
            callMSGraph(graphConfig.graphMailEndpoint, response.accessToken, updateUI);
        }).catch(error => {
            console.error(error);
        });
}

export {signIn, signOut};

// Verificar estado de autenticación en la carga de la página
window.onload = function() {
    // Obtiene el pathname de la URL actual
    const currentPath = window.location.pathname;
    const pageName = currentPath.substring(currentPath.lastIndexOf('/') + 1);
    const isAuthenticated = localStorage.getItem('authenticated');
    if (isAuthenticated === 'true') {
        getTokenRedirect(tokenRequest)
            .then(resp => {
                localStorage.setItem('id_token', resp.accessToken);
                localStorage.setItem('authenticated', 'true');  // Marcamos como autenticado
                //if (pageName === 'login' || pageName === '') {
                if (pageName === 'login') {
                    window.location.replace('cuadroMando');  // Una vez logeado y conseguido el token, cargamos la página de cuadroMando.
                }
            })
            .catch(error => {
                console.error("Error al adquirir el token:", error);
            });
    }
};